// "Spot the Slip" expansion — FOOD theme. Shape:
//   [ wrong, right, tag, why, slug ]

export const CORRECTIONS_FOOD = [
  ["A sopa é muito quente, espera.", "A sopa está muito quente, espera.", "ser-estar",
    "Temperature right now is a changeable state → estar.", "ser-vs-estar"],
  ["O frango ainda é cru.", "O frango ainda está cru.", "ser-estar",
    "Cru here is a current condition (not yet cooked) → estar.", "ser-vs-estar"],
  ["Este bacalhau é delicioso, o meu prato preferido.", "Este bacalhau é delicioso, o meu prato preferido.", "ser-estar",
    "Trap check: a defining quality of the dish correctly uses ser. (Already correct!)", "ser-vs-estar"],
  ["Tenho um frigideira nova.", "Tenho uma frigideira nova.", "gender",
    "Frigideira is feminine → uma frigideira.", "gender-agreement-of-nouns"],
  ["A arroz já está pronto.", "O arroz já está pronto.", "gender",
    "Arroz is masculine → o arroz.", "gender-agreement-of-nouns"],
  ["As batatas fritos estão boas.", "As batatas fritas estão boas.", "gender",
    "Fritas must agree with the feminine plural batatas.", "adjective-agreement"],
  ["Gosto de as bananas maduras.", "Gosto das bananas maduras.", "gustar",
    "Gostar takes de; de + as = das.", "gostar-and-similar-verbs"],
  ["Apetece-me uns petiscos antes do jantar.", "Apetecem-me uns petiscos antes do jantar.", "gustar",
    "Apetecer agrees with its subject; plural snacks → apetecem.", "gostar-and-similar-verbs"],
  ["Comprei pão para dez euros.", "Comprei pão por dez euros.", "por-para",
    "An exchange of money for goods uses por.", "por-vs-para"],
  ["Este bolo é para a minha mãe.", "Este bolo é para a minha mãe.", "por-para",
    "Trap check: the recipient of something correctly uses para. (Already correct!)", "por-vs-para"],
  ["O sal? Passa a mim, por favor.", "O sal? Passa-mo, por favor.", "pronoun-order",
    "Attach indirect + direct together: me + o (o sal) → passa-mo.", "object-pronouns"],
  ["Ontem cozinhava um bacalhau para toda a família.", "Ontem cozinhei um bacalhau para toda a família.", "preterito-imperfecto",
    "A single, completed cooking event takes the pretérito perfeito → cozinhei.", "a2-preterito-vs-imperfeito"],
  ["O pessego da frutaria estava muito maduro.", "O pêssego da frutaria estava muito maduro.", "accents",
    "Pêssego is proparoxytone with a closed e → circumflex ê.", "stress-and-written-accents"],
  ["Quero que a sopa tem menos sal.", "Quero que a sopa tenha menos sal.", "subjunctive",
    "A wish about the dish (querer que) triggers the conjuntivo → tenha.", "b1-present-subjunctive"],
  ["Procuro um restaurante que serve comida vegana.", "Procuro um restaurante que sirva comida vegana.", "subjunctive",
    "An as-yet-unknown place you're looking for triggers the conjuntivo → sirva.", "b1-present-subjunctive"],
];
